const Notification = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_1437)">
        <path
          d="M21.5303 14.4697L19.5 12.4394V9.75C19.4976 7.89146 18.8061 6.09983 17.5593 4.72154C16.3126 3.34326 14.599 2.47622 12.75 2.2881V0.75H11.25V2.2881C9.40101 2.47622 7.68744 3.34326 6.44065 4.72154C5.19386 6.09983 4.50241 7.89146 4.5 9.75V12.4394L2.46968 14.4697C2.32904 14.6104 2.25002 14.8011 2.25 15V17.25C2.25 17.4489 2.32902 17.6397 2.46967 17.7803C2.61032 17.921 2.80109 18 3 18H8.25V18.5826C8.23374 19.534 8.56913 20.458 9.19191 21.1775C9.81469 21.897 10.6811 22.3613 11.625 22.4816C12.1464 22.5334 12.6728 22.4754 13.1704 22.3115C13.668 22.1475 14.1258 21.8813 14.5143 21.5298C14.9029 21.1783 15.2135 20.7494 15.4263 20.2707C15.6391 19.7919 15.7494 19.2739 15.75 18.75V18H21C21.1989 18 21.3897 17.921 21.5303 17.7803C21.671 17.6397 21.75 17.4489 21.75 17.25V15C21.75 14.8011 21.671 14.6104 21.5303 14.4697ZM14.25 18.75C14.25 19.3467 14.0129 19.919 13.591 20.341C13.169 20.7629 12.5967 21 12 21C11.4033 21 10.831 20.7629 10.409 20.341C9.98705 19.919 9.75 19.3467 9.75 18.75V18H14.25V18.75ZM20.25 16.5H3.75V15.3106L5.78025 13.2802C5.92091 13.1396 5.99996 12.9489 6 12.75V9.75C6 8.1587 6.63214 6.63258 7.75736 5.50736C8.88258 4.38214 10.4087 3.75 12 3.75C13.5913 3.75 15.1174 4.38214 16.2426 5.50736C17.3679 6.63258 18 8.1587 18 9.75V12.75C18 12.9489 18.0791 13.1396 18.2197 13.2802L20.25 15.3106V16.5Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_1437">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Notification;
